import React from "react";
import PropTypes from "prop-types";
import {
  Grid,
  CardMedia,
  CardContent,
  Typography,
  Card,
  CardActions,
  Tooltip,
} from "@material-ui/core";
import { Delete, Phone } from "@material-ui/icons";

const CardView = ({ students, School, openDialog, deleteStudents, is_admin, staff_member_admin }) => {
  return (
    <Grid container spacing={2} style={{ padding: "25px 10px" }}>
      {(students.data || []).map((stu) => {
        return (
          <Grid item key={stu.id} xs={12} sm={6} md={3}>
            <Card>
              <CardMedia
                style={{ height: 125 }}
                image={
                  stu.user?.avatar_thumb ? stu.user.avatar_thumb : stu.user?.avatar
                }
                title="user"
              />
              <CardContent>
                <Typography variant="h5">
                  {stu.user?.first_name}{" "}
                  <span style={{ fontSize: "1rem" }}>{stu.user?.last_name}</span>
                </Typography>
                <Typography>
                  Team: {stu.team?.name ?? ""}
                </Typography>
                <Typography>Email: {stu.user?.email}</Typography>
                <Typography variant="body2" color="textSecondary">
                  <School className="mr-1" /> {stu.classification}
                </Typography>
                <Typography variant="body2" color="textSecondary">
                  <Phone className="mr-1" /> {stu.user?.phone_number}
                </Typography>
              </CardContent>
              <CardActions disableSpacing className="justify-content-end">
                <Tooltip title="Edit Athlete" placement="top">
                  {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                  <a
                    id={`edit_student_btn_${stu.id}_card`}
                    className="btn btn-icon btn-sm btn-light btn-hover-primary"
                    href="#"
                    onClick={() => openDialog("editing", stu.id)}
                  >
                    <i className="fas fa-edit text-primary" />
                  </a>
                </Tooltip>
                {(staff_member_admin || is_admin) && (
                  <Tooltip title="Delete Athlete" placement="top">
                    {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                    <a
                      id={`delete_student_btn_${stu.id}_card`}
                      className="btn btn-icon btn-sm btn-light btn-hover-danger text-danger mx-3"
                      href="#"
                      onClick={() => deleteStudents(stu.id)}
                    >
                      <Delete />
                    </a>
                  </Tooltip>
                )}
              </CardActions>
            </Card>
          </Grid>
        );
      })}
    </Grid>
  );
};

CardView.propTypes = {
  students: PropTypes.shape({
    data: PropTypes.arrayOf(PropTypes.object).isRequired,
  }).isRequired,
  School: PropTypes.elementType.isRequired,
  openDialog: PropTypes.func.isRequired,
  deleteStudents: PropTypes.func.isRequired,
  is_admin: PropTypes.bool,
  staff_member_admin: PropTypes.bool,
};

export default CardView;
